import Button from "@/components/base/Button";
import ProductCard from "@/pages/home/components/ProductCard";
import type { ProductItem } from "@/pages/home/types";

interface ProductSectionProps {
  id: string;
  eyebrow?: string;
  title: string;
  subtitle: string;
  items: ProductItem[];
  background?: "light" | "surface";
  ctaLabel?: string;
  ctaHref?: string;
  ctaExternal?: boolean;
}

export default function ProductSection({
  id,
  eyebrow,
  title,
  subtitle,
  items,
  background = "light",
  ctaLabel,
  ctaHref,
  ctaExternal = true,
}: ProductSectionProps) {
  const sectionBg = background === "surface" ? "bg-background-100" : "bg-background-50";

  return (
    <section id={id} className={`w-full scroll-mt-24 ${sectionBg}`}>
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-24">
        <div className="reveal mx-auto mb-10 max-w-2xl text-center md:mb-14">
          {eyebrow && (
            <span className="text-xs font-label font-semibold uppercase tracking-[0.18em] text-primary-700">
              {eyebrow}
            </span>
          )}
          <h2 className="mt-3 text-3xl font-semibold md:text-[40px]">{title}</h2>
          <p className="mt-4 text-base text-foreground-600 md:text-lg">{subtitle}</p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:gap-6 lg:grid-cols-3">
          {items.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {ctaLabel && ctaHref && (
          <div className="mt-10 flex justify-center md:mt-12">
            <Button
              href={ctaHref}
              variant="outline"
              external={ctaExternal}
              fbEvent="ClicTiendaOnline"
              fbLabel="generico"
              className="px-6 py-3 text-base"
            >
              {ctaLabel}
              <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
            </Button>
          </div>
        )}

        <p className="mt-8 text-center text-xs text-foreground-500 md:text-sm">
          La disponibilidad puede variar en el punto de venta.
        </p>
      </div>
    </section>
  );
}